export const DEFAULT_SEVERITIES = {
    // Alerts
    critical: {
        icon: 'mdi-alert-octagon',
        notification_icon: 'mdi-alert-octagon',
        color: '#d12021',
        weight: 1000,
    },
    fault: {
        icon: 'mdi-alert-box',
        notification_icon: 'mdi-alert-box',
        color: '#d12021',
        weight: 900,
    },
    blocked: {
        icon: 'mdi-close-circle',
        notification_icon: 'mdi-close',
        color: '#d12021',
        weight: 600,
    },
    minor: {
        icon: 'mdi-alert',
        notification_icon: 'mdi-alert',
        color: '#FFBA00',
        weight: 400,
    },
    major: {
        icon: 'mdi-alert-box',
        notification_icon: 'mdi-alert-box',
        color: '#F47F16',
        weight: 650,
    },
    warning: {
        icon: 'mdi-alert-circle',
        notification_icon: 'mdi-alert-circle',
        color: '#ffba00',
        weight: 625,
    },
    alert: {
        icon: 'mdi-bell-circle',
        notification_icon: 'mdi-bell',
        color: '#d12021',
        weight: 700,
    },
    error: {
        icon: 'mdi-close-circle',
        notification_icon: 'mdi-close',
        color: '#d12021',
        weight: 800,
    },
    failed: {
        icon: 'mdi-close-circle',
        notification_icon: 'mdi-close',
        color: '#d12021',
        weight: 950,
    },
    cleared: {
        icon: 'mdi-checkbox-marked-circle',
        notification_icon: 'mdi-checkbox-marked',
        color: '#74a534',
        weight: 100,
    },
    success: {
        icon: 'mdi-checkbox-marked-circle',
        notification_icon: 'mdi-check-bold',
        color: '#74a534',
        weight: 150,
    },
    indeterminate : {
        icon: 'mdi-help-circle',
        notification_icon: 'mdi-help',
        color: '#B0B9BF',
        weight: 225,
    },
    debug: {
        icon: 'mdi-bug',
        notification_icon: 'mdi-bug',
        color: '#050000',
        weight: 10,
    },
    info: {
        icon: 'mdi-information',
        notification_icon: 'mdi-information',
        color: '#00B6F1',
        weight: 100,
    },
    notice: {
        icon: 'mdi-chat-alert',
        notification_icon: 'mdi-chat-alert',
        color: '#0F73C3',
        weight: 300,
    },
    emergency : {
        icon: 'mdi-hospital-box',
        notification_icon: 'mdi-hospital',
        color: '#d12021',
        weight: 750,
    },
    healthy: {
        icon: 'mdi-check-circle',
        notification_icon: 'mdi-check',
        color: '#74a534',
        weight: 75,
    },
    normal: {
        icon: 'mdi-check-circle',
        notification_icon: 'mdi-check',
        color: '#74a534',
        weight: 50,
    },
    registered: {
        icon: 'mdi-check-circle',
        notification_icon: 'mdi-check',
        color: '#00B6F1',
        weight: 20,
    },
    ok: {
        icon: 'mdi-check-circle',
        notification_icon: 'mdi-check',
        color: '#74a534',
        weight: 60,
    },
    degraded: {
        icon: 'mdi-alert',
        notification_icon: 'mdi-alert',
        color: '#F47F16',
        weight: 735,
    },
    rebuilding: {
        icon: 'mdi-reload',
        notification_icon: 'mdi-reload',
        color: '#F47F16',
        weight: 550,
    },
    awaiting: {
        icon: 'mdi-timer-sand',
        notification_icon: 'mdi-timer-sand',
        color: '#F47F16',
        weight: 625,
    },
    unknown: {
        icon: 'mdi-help-circle',
        notification_icon: 'mdi-help',
        color: '#B0B9BF',
        weight: 90,
    },
    na: {
        icon: 'mdi-dots-horizontal-circle',
        notification_icon: 'mdi-dots-horizontal',
        color: '#B0B9BF',
        weight: 45,
    },
    offline: {
        icon: 'mdi-close-circle',
        notification_icon: 'mdi-close',
        color: '#d12021',
        weight: 775,
    },
};
